/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react"
import { connect } from "react-redux"

import PriceForm from "../PriceForm";

import { createPriceAction } from "../../../../redux/actions/priceActions";
import { getSettingsItemAction } from '../../../../redux/actions/settingsActions';
import { getItemSelector } from "../../../../utils/selectors";
import { APP_SETTING_KEYS } from '../../../../constants/enums';

const CreatePrice = ({
    createPriceAction,
    getSettingsItemAction,
    defaultCurrency,
    tableParams,
    history
}) => {

    useEffect(() => {
        getSettingsItemAction(APP_SETTING_KEYS.DEFAULT_CURRENCY);
    }, [])

    const onSubmit = data => {
        if (data.price) {
            data.price = parseFloat(data.price);
        }
        createPriceAction(data, tableParams);
    }

    const handleCancel = () => {
        history.goBack();
    }

    return (
        <PriceForm
            title="general.createPrice"
            onSubmit={onSubmit}
            submitLabel="general.createPrice"
            handleCancel={handleCancel}
            defaultCurrency={defaultCurrency}
        />
    )
}

const mapStateToProps = state => ({
    tableParams: state.tableParams,
    defaultCurrency: getItemSelector(state.settingsItem)
})

const mapDispatchToProps = {
    createPriceAction,
    getSettingsItemAction
};

export default connect(mapStateToProps, mapDispatchToProps)(CreatePrice);
